import { IconType } from "./icons.types";

export const BoxIcon = ({ className, color = "#00BAD1" }: IconType) => {
  return (
    <svg
      width="41"
      height="45"
      viewBox="0 0 41 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.333252 15.422L17.5339 25.3528C17.7191 25.4597 17.9133 25.5369 18.111 25.586V44.8463L1.56001 35.0513C0.79963 34.6013 0.333252 33.7834 0.333252 32.8999V15.422ZM40.3332 15.158V32.8999C40.3332 33.7834 39.8669 34.6014 39.1065 35.0513L22.5555 44.8463V25.4172C22.5958 25.3971 22.6358 25.3756 22.6753 25.3528L40.3332 15.158Z"
        fill={color}
      />
      <path
        opacity="0.499209"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.873535 10.6019C1.08364 10.3366 1.34882 10.1124 1.65799 9.94772L19.158 0.62684C19.8926 0.235552 20.7738 0.235552 21.5085 0.62684L39.0085 9.94772C39.2468 10.0747 39.459 10.237 39.64 10.4263L20.4531 21.5038C20.3269 21.5766 20.2106 21.66 20.1046 21.7521C19.9986 21.66 19.8823 21.5766 19.7561 21.5038L0.873535 10.6019Z"
        fill={color}
      />
    </svg>
  );
};
